// extracted by mini-css-extract-plugin
module.exports = {"section":"vantagens_section__ZTqHs","cards":"vantagens_cards__bga9x","card":"vantagens_card__fGJpt","icon":"vantagens_icon__8BBtL"};